import axios from 'axios'
import vueStore from '@/store'

// const store = new Store()

// const serverAddress = store.get('serverAddress')
const token = vueStore.state.auth.token

const protocol = process.env.NODE_ENV === 'production' ? 'https' : 'http'

export default axios.create({
  baseURL: `${protocol}://${process.env.VUE_APP_SERVER_DNS}/api/`,
  headers: {
    // 'Content-Type': 'application/x-www-form-urlencoded',
    Authorization: `Bearer ${token}`,
  },
})
